// @ts-nocheck
/// <reference path="../../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
import * as React from 'react';
import { RCUtils } from './../../../RCUtils';
import HighCC from '../../../images/Status/Alarms/HighCC.png';
import MediumCC from '../../../images/Status/Alarms/MediumCC.png';
import LowCC from '../../../images/Status/Alarms/LowCC.png';
var Config: any = require('../../../Config.json');
var self;
export default class CCAlmTooltip extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loading: true,
            ccAlertData: []
        }
        self = this;
    }

    getReactContainerClasses() {
        var propsdata = this.props;
        if (propsdata.data != null && propsdata.data != undefined && 
            propsdata.data.CCProfileCode != null && propsdata.data.CCProfileCode != '') {
            if (propsdata.data.UnitControlEventID != null && propsdata.data.UnitControlEventID != undefined && propsdata.data.UnitControlEventID != ''
                && propsdata.data.CCAlarms != null && propsdata.data.CCAlarms != '') {
                return ['custom-tooltip'];
            }
        }
        else {
            return ['custom-tooltipSmall'];
        }
    }
    componentDidMount() {
        var propsdata = this.props;
        if (propsdata.data != null && propsdata.data != undefined &&
            propsdata.data.CCProfileCode != null && propsdata.data.CCProfileCode != '') {
            if (propsdata.data.CCAlarmsList != null && propsdata.data.CCAlarmsList != undefined && propsdata.data.CCAlarmsList != ''
                && propsdata.data.CCAlarms != null && propsdata.data.CCAlarms != '') {
                  var finalList =[];
                var lstAlerts = propsdata.data.CCAlarmsList.split(',');
                    $.each(lstAlerts, function (index, item) {
                            if (item != "" && item != null) {
                                 var iList  = item.split(':');
                                    finalList.push(iList);
                                }
                            });
                 this.setState({ ccAlertData: finalList, loading: false });
            }
        }
    }
    GetAlarmDescription(almCode:any){
            var alarmDescription = "";
            var almCd = almCode != "" ? almCode.trim() :'';
        if (this.props.colDef.cellRendererParams.almData != undefined && this.props.colDef.cellRendererParams.almData != 'undefined')
        {
                var alarmsList = this.props.colDef.cellRendererParams.almData
                var alarmDescriptions = alarmsList.filter(e => e.AlarmCd === almCd);
                    if(alarmDescriptions.length > 0)
                        {
                           alarmDescription= alarmDescriptions[0].Description;
                        }
        }
        return alarmDescription; 
    }
    render() {
        return (
            self.props.data != null && self.props.data != undefined &&
                self.props.data.CCProfileCode != null && self.props.data.CCProfileCode != '' ?
                <div className='agGridTooltip'>
                    <div className="custom-tooltip">
                        <div className='headingToolTip'>
                   {this.props.data.CCProfileCode}        
                       
                        </div>

                    {this.state.ccAlertData != null && this.state.ccAlertData != undefined && this.props.data.CCAlarms != null && this.props.data.CCAlarms != '' ? this.state.loading == false ? this.state.ccAlertData.map(function (almData, index) {

                    return (
                        <div className='TooltipHeight ps-1'>
                            
                            <ul className="list-group">
                                {
                                    <li key={almData[0]} className='mt-1 me-1'>
                                        <div className='flex-container '>
                                            <div>{almData[1] == "1" ? <img className="Rssiformatter float-start me-1" src={HighCC} width="20" height="20" />
                                                : almData[1] == "2" ? <img className="Rssiformatter float-start me-1" src={MediumCC} width="20" height="20" /> : almData[1] == "3" ? <img className="Rssiformatter float-start me-1" src={LowCC} width="20" height="20" /> : ''}</div>
                                            <div className='flex-container pt-1'>
                                            <div className='me-1'>{almData[0]} </div>
                                            <div className='width10'> : </div>
                                            <div> <div className='CCColumnEllipsis'> {self.GetAlarmDescription(almData[3])} </div> </div>
                                                <div className='ps-1'> : </div>
                                                <div className='ps-1 CCColumnEllipsis'>{almData[2]}</div>
                                            </div>
                                        </div>
                                    </li>

                                }
                            </ul>

                        </div>)
                    }) : 'Loading...' : <div className='ms-1'>  All clear. No active alerts.</div>
                    }
                

                    </div></div> : null)

    }
}
